var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-header",
        {
          ref: "header",
          staticClass: "header",
          staticStyle: { height: "auto", "margin-bottom": "10px" },
        },
        [
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "div",
                { attrs: { id: "searchBox" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "xhname" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入型号" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.xhname,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "xhname", $$v)
                          },
                          expression: "searchForm.xhname",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "company" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入公司名" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.company,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "company", $$v)
                          },
                          expression: "searchForm.company",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "orderid" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入合同编号" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.orderid,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderid", $$v)
                          },
                          expression: "searchForm.orderid",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "gongyingshang" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入采购渠道" },
                        nativeOn: {
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearchBtn.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchForm.gongyingshang,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "gongyingshang", $$v)
                          },
                          expression: "searchForm.gongyingshang",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "sfkp" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "是否开票", clearable: "" },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearchBtn.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchForm.sfkp,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "sfkp", $$v)
                            },
                            expression: "searchForm.sfkp",
                          },
                        },
                        _vm._l(_vm.isInvoicing, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { value: item.value, label: item.label },
                            },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "sfsp" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "收票状态", clearable: "" },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearchBtn.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchForm.sfsp,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "sfsp", $$v)
                            },
                            expression: "searchForm.sfsp",
                          },
                        },
                        _vm._l(_vm.receiptStatus, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { value: item.value, label: item.label },
                            },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "", prop: "ow_type" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "出库状态", clearable: "" },
                          nativeOn: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleSearchBtn.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.searchForm.ow_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "ow_type", $$v)
                            },
                            expression: "searchForm.ow_type",
                          },
                        },
                        _vm._l(_vm.ckTypeStatus, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { value: item.value, label: item.label },
                            },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { type: "text", id: "closeSearchBtn" },
                      on: { click: _vm.closeSearch },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.word) + " "),
                      _c("i", {
                        class: _vm.showAll
                          ? "el-icon-arrow-up "
                          : "el-icon-arrow-down",
                      }),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: { click: _vm.handleSearchBtn },
                    },
                    [_vm._v("搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: { click: _vm.handleResetBtn },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-table" },
        [
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              staticClass: "el-icon-download",
              attrs: {
                loading: _vm.exportLoading,
                type: "success",
                size: "small",
              },
              on: { click: _vm.handleExport },
            },
            [_vm._v("导出Excel ")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.toggleExpand },
            },
            [_vm._v(" " + _vm._s(_vm.isExpanded ? "收起" : "展开") + " ")]
          ),
          _c(
            "el-table",
            {
              ref: "tableRef",
              staticClass: "customer-table",
              attrs: {
                border: "",
                fit: "",
                "highlight-current-row": "",
                "row-key": "id",
                data: _vm.list,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("Expand", {
                          attrs: { data: row.childdata, parentId: row.id },
                          on: {
                            updateExpand: _vm.handleUpdateExpand,
                            deleteRow: _vm.handleDeleteRow,
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", { attrs: { label: "ID", prop: "id" } }),
              _c("el-table-column", {
                attrs: { label: "所属公司", prop: "company", width: "300" },
              }),
              _c("el-table-column", {
                attrs: { label: "合同编号", prop: "orderid", width: "140" },
              }),
              _c("el-table-column", {
                attrs: { label: "型号", prop: "xhname", width: "200" },
              }),
              _c("el-table-column", {
                attrs: { label: "品牌", prop: "source", width: "200" },
              }),
              _c("el-table-column", { attrs: { label: "数量", prop: "num" } }),
              _c("el-table-column", {
                attrs: { label: "单价", prop: "price" },
              }),
              _c("el-table-column", {
                attrs: { label: "总价", prop: "zprice" },
              }),
              _c("el-table-column", {
                attrs: { label: "出库状态", prop: "ck_type" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.ck_type == "T" || scope.row.ck_type == "F"
                          ? _c("el-button", {
                              staticStyle: { "font-size": "20px" },
                              style:
                                scope.row.ck_type == "T"
                                  ? "color: green"
                                  : "color:red",
                              attrs: {
                                type: "text",
                                icon:
                                  scope.row.ck_type == "T"
                                    ? "el-icon-success"
                                    : "el-icon-error",
                              },
                            })
                          : _c("span", [_vm._v(_vm._s(scope.row.ck_type))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "成本价", prop: "cgzprice" },
              }),
              _vm.isShowOperationBtn
                ? _c("el-table-column", {
                    attrs: { label: "操作", width: "200" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  staticClass: "el-icon-position",
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleOutbound(
                                        scope.row.xhname,
                                        scope.row.id,
                                        scope.row.num
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 出库 ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2762151338
                    ),
                  })
                : _vm._e(),
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "14px", "margin-bottom": "14px" },
            attrs: {
              "current-page": _vm.selectPage.pageNum,
              "page-sizes": [20, 50, 100, 200],
              "page-size": _vm.selectPage.pageSize,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.allNum,
            },
            on: {
              "size-change": _vm.pageSizeChange,
              "current-change": _vm.pageCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("Outbound", {
        attrs: {
          dialog: _vm.outboundDialog,
          parentId: _vm.parentId,
          xhName: _vm.xhName,
          contractNum: _vm.contractNum,
        },
        on: { close: _vm.handleClose, outboundSuccess: _vm.outboundSuccess },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }